const statuses = {
  unconfigured: { text: '准备中', color: 'default' },
  not_created: { text: '未创建', color: 'default' },
  missing: { text: '准备中', color: 'processing' },
  stopped: { text: '准备中', color: 'processing' },
  starting: { text: '准备中', color: 'processing' },
  creating: { text: '准备中', color: 'processing' },
  recovering: { text: '准备中', color: 'processing' },
  upgrading: { text: '升级中', color: 'processing' },
  pending: { text: '等待中', color: 'processing' },
  pulling: { text: '拉取镜像中', color: 'processing' },
  running: { text: '运行中', color: 'success' },
  completed: { text: '升级完成', color: 'success' },
  cleanup_pending: { text: '等待清理', color: 'warning' },
  failed: { text: '失败', color: 'error' },
  error: { text: '失败', color: 'error' },
};

export const canManageHarness = (role) => ['owner', 'admin'].includes(role);

export const getHarnessWebUrl = (organizationId, apiBase = process.env.VITE_API_BASE || '') => {
  if (!organizationId) {
    throw new Error('缺少组织');
  }
  const origin = apiBase && !apiBase.startsWith('/') ? new URL(apiBase).origin : '';
  return `${origin}/harness/${encodeURIComponent(organizationId)}/`;
};

export const getHarnessStatus = (status) =>
  statuses[status] || { text: status || '未知', color: 'default' };

export const isHarnessBusy = (status) =>
  ['starting', 'creating', 'recovering', 'upgrading', 'pending', 'pulling'].includes(status);

export const canStartHarness = (status, error) =>
  error !== 'HARNESS_UPGRADE_FAILED' &&
  ['unconfigured', 'not_created', 'missing', 'stopped', 'failed', 'error'].includes(status);

export const getHarnessFrameSrc = (currentSrc, status, src) =>
  currentSrc || (status === 'running' ? src : undefined);
